import { render, staticRenderFns } from "./SmartAbHistory.vue?vue&type=template&id=1ddcae20&scoped=true&"
import script from "./SmartAbHistory.vue?vue&type=script&lang=ts&"
export * from "./SmartAbHistory.vue?vue&type=script&lang=ts&"
import style0 from "./SmartAbHistory.vue?vue&type=style&index=0&id=1ddcae20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddcae20",
  null
  
)

export default component.exports